  import React, { useEffect, useState } from 'react';
import { DataGrid, GridToolbar} from '@mui/x-data-grid';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { Button, Box, IconButton, CircularProgress, Chip, Typography, Tooltip, Input } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import { toast } from 'sonner';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';


const MemberActions = ({params}) => {
  const navigate = useNavigate();
  const handlePsb = () => {
    navigate('/onemember/', {state: {
      Member_id: params.row.Member_id,
      Fullname: params.row.Fullname,
    } })
  }
    return(
      <Button variant='outlined' onClick={handlePsb}>View</Button>
    )
};

export const PassbookEdit = ({params, fetchMembers}) => {
  const [original_p, setOriginal_P] = useState('');
  const [hu, setHu] = useState(false);
  const [init,setInit] = useState('');
  const [loading, setLoading] = useState(false)

  const fetch_p_Id = () => {
    const cacheKey = `passbook_id_${params.row.PassBook_id}`;
    const cachedData = localStorage.getItem(cacheKey);
  
    if (cachedData) {
      const parsedData = JSON.parse(cachedData);
      setOriginal_P(parsedData.pass_id);
      setInit(parsedData.initials);
    } else {
      api.get(`/members/member/passbook_id/${params.row.PassBook_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        const data = {
          pass_id: response.data?.pass_id,
          initials: response.data?.initials,
        };
        setOriginal_P(data.pass_id);
        setInit(data.initials);
        localStorage.setItem(cacheKey, JSON.stringify(data)); // Cache the fetched data
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  };
  
  useState(()=>{
    fetch_p_Id();
  },[])

  const handelpp = () => {
    setHu(true)
  }
  const closeFormm = () => {
    setHu(false);
    memik.handleReset();
  }

  const memik = useFormik({
    initialValues: {
      new_passbook_id: original_p,
  },
  validationSchema: Yup.object({
    new_passbook_id: Yup.string().matches(new RegExp(`^${init}\\d{3}$`), {
      message: `Invalid format. Should start with the Kind first Character, then Savings Groups first two characters(${init}) followed by three digit.`,})
  }),
  onSubmit: (values) => {
      setLoading(true)
      const j = new FormData()
      j.append('association_member_id', params.row.PassBook_id)
      j.append('new_passbook_id', values.new_passbook_id)

      api.post('/members/update/passbook_id', j,{
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        }
      }).then(function(response){
        toast.success(response.data)
        fetch_p_Id();
        fetchMembers()
        closeFormm();
      }).catch(function(error){
        console.log(error)
      }).finally(function (){
        setLoading(false)
      });

  }
})



    return(
    <>
    <IconButton onClick={handelpp}><EditIcon /></IconButton>
    <Dialog open={hu} onClose={closeFormm}>
                <form onSubmit={memik.handleSubmit}>
                <DialogTitle>Edit Passbook Number</DialogTitle>
                <DialogContent>
                
                <TextField
                    margin="dense"
                    size="small"
                    sx={{ borderRadius: 4, m:2 }}
                    name="new_passbook_id"
                    label="New Passbook number"
                    type="text"
                    value={memik.values.new_passbook_id}
                    onChange={memik.handleChange}
                    variant="standard"
                    onBlur={memik.handleBlur}
                    error={memik.touched.new_passbook_id && Boolean(memik.errors.new_passbook_id)}
                    helperText={memik.touched.new_passbook_id && memik.errors.new_passbook_id}
                />
                
                </DialogContent>
                <DialogActions>
                <Button
                    size='small'
                    onClick={closeFormm}
                    color='error'
                    variant='contained'
                    sx={{ m:2 }}
                >
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    type='submit'
                    color='success'
                    size='small'
                    disabled={loading === true? true: false}
                    sx={{ m:2 }}
                >
                    {
                        loading === true ?
                        <Box sx={{ width: '100%' }}>
                            <CircularProgress />
                        </Box>
                        : "Change"
                    }
                </Button>
                </DialogActions>
                </form>
            </Dialog>
        </>
  )
}



const AssociationMembers = (props) => {
  const [members, setMembers] = useState({});
  const [deleteMemberModalOpen, setDeleteMemberModalOpen] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(null);
  const [personaInfo, setPersonaInfo] = useState([]);

  const handleDeleteMemberClick = (member) => {
    setMemberToDelete(member);
    setDeleteMemberModalOpen(true);
  };

  const deleteMember = async () => {
    if (!memberToDelete) return;
    toast.promise(
      api
      .get(
        `/association/delete/member/${memberToDelete.Member_id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }
      ),
      {
          loading: "Deleting Member And Related Contents...",
          success: (response) => {
              fetchMembers();
              setDeleteMemberModalOpen(false);
              setMemberToDelete(null);
              return response.data
          },
          error: (error) => {
              console.log(error);
              
              return 'Error, Please try again'
          }
      }
    )
  };

  const id = props.id 
  const fetchMembers = () => {
    api.get(`/members/allmembers/${id}`,{
      headers: {
        Authorization: 'Bearer ' + fetchToken()
      }
    }).then(function (response) {
      setMembers(response.data);
      // console.log(response)
    }).catch(function(error){
      console.log(error)
    })
    api
      .get("/users/su", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setPersonaInfo(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
const [idd, setIdd] = useState(20)
  const fetchMembersthirty = () => {
    console.log(idd)
    toast.promise(
      api.get(`/members/allmembers/thirty/${idd}`,{
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }),
      {
        loading: "Loading..",
        success: (res) => {
          setMembers(res.data);
          return "Done"
        },
        error: (err) => {
          console.log(err)
          return "Error"
        }
      }
    )
  };
  useEffect(() => {
    fetchMembers()
  }, [id])

  function formatDateToYareMonthDay(date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = 'th';
  
    if (day === 1 || day === 21 || day === 31) {
      suffix = 'st';
    } else if (day === 2 || day === 22) {
      suffix = 'nd';
    } else if (day === 3 || day === 23) {
      suffix = 'rd';
    }
  
    return `${day}${suffix} ${month} ${year}`;
  }
  const columns = [
        {
            field: "Member_id",
            headerName: "ID",
            flex:1,
            width: 70,
        },
        {
            field: "Fullname",
            headerName: 'Member Name',
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "CommonName",
            headerName: 'Common Name',
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "PassBook_id",
            headerName: "bond_id",
            flex: 1,
            width:70
        },
        {
          field: "Original_pass",
          headerName: "Passbook Id",
          flex: 1,
          width:70
        },
        {
          field: "card_type",
          headerName: "Card Type",
          flex: 1,
        },
        {
            field: "GhCardNumber",
            headerName: "Ghana Card Number",
            flex: 1,
        },
        {
          field: "Phone",
          headerName: "Contact Number",
          flex: 1,
        },
        {
          field: "dob",
          headerName: "Date of Birth",
          flex: 1,
          renderCell: (params) => formatDateToYareMonthDay(new Date(params.row.dob))
        },
        {
          field: "age",
          headerName: "Age(years)",
          flex: 1,
        },
        {
          field: "gender",
          headerName: "Gender",
          flex: 1,
        },
        {
          field: "marital_status",
          headerName: "Marital Status",
          flex: 1,
        },
        {
          field: "rural_or_urban",
          headerName: "Area Type",
          flex: 1,
        },
        {
          field: "Education_level",
          headerName: "Education level",
          flex: 1,
        },
        {
            field: "main_crop",
            headerName: 'Main Crop',
            flex: 1,
        },
        {
            field: "farmer_language",
            headerName: 'Language',
            flex: 1,
        },
        {
            field: "land_size_acres",
            headerName: 'Land Size(acres)',
            flex: 1,
        },
        {
          field: "land_location",
          headerName: 'Land Location',
          flex: 1,
          renderCell: params => {
              const handleClick = () => {
                  const url = params.row.land_location;
                  if (!url){
                    toast.warning('Link is not available')
                  }else{
                    window.open(url, '_blank');
                  }
              };
              return (
                  <Chip 
                      size='small'
                      label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Map</b></Typography>}
                      sx={{
                        borderRadius: 2,
                        m: 1,
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#2b2d42',
                        color: '#fff',
                        '&:hover': {
                          boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                          backgroundColor: '#14213d',
                        },
                      }} 
                      onClick={() => handleClick()} 
                  />
              );
            }
        },
        {
            field: "association_name",
            headerName: 'Association',
            flex: 1,
        },

        {
            field: "community",
            headerName: 'Community',
            flex: 1,
        },
        {
            field: "cluster",
            headerName: 'Cluster',
            flex: 1,
        },
        {
            field: "society",
            headerName: 'Society',
            flex: 1,
        },
        {
            field: 'actions',
            type: 'actions',
            renderCell:params => <MemberActions {...{params}} />
        },
        {
          field: 'edit',
          type: 'actions',
          renderCell:params => <PassbookEdit {...{params, fetchMembers }} />
      },
      {
        field: 'delete',
        type: 'actions',
        renderCell: params => (
        <>
        {personaInfo?.role_name === 'Administrator'?(
          <Button
              size="small"
              color="error"
              variant="contained"
              sx={{
              borderRadius: 2,
              mr: 'auto',
              boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
              "&:hover": {
                  boxShadow:
                  "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
              },
              }}
              onClick={() => handleDeleteMemberClick(params.row)}
          >
              <DeleteRoundedIcon />
          </Button>)
          :null}
        </>
        )
    }
    ]


    


  return (
    <div>
      {/* <Tooltip
        title={(
          <TextField
            value={idd}
            onChange={(e) => setIdd(e.target.value)}
            name="idd"
          />)
        }
      >
        <Chip 
        label='35'
        onClick={fetchMembersthirty}
      />
      </Tooltip> */}
      
      <Box
          m="40px 0 0 0"
          height="75vh"
          paddingBottom="35px"
      >
        <DataGrid
            rows={members}
            columns={columns}
            autoHeight
            checkboxSelection
            getRowId={(row) => row.PassBook_id}
            slots={{ toolbar: GridToolbar }}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  PassBook_id: false,
                  Member_id:false,
                  CommonName:false,
                  marital_status:false,
                  rural_or_urban:false,
                  Education_level:false,
                  dob:false,
                  community:false,
                  cluster:false,
                  society:false,
                  association_name:false
                },
              },
            }}
        />
        {/* Delete Member Confirmation Modal */}
<Dialog
  open={deleteMemberModalOpen}
  onClose={() => setDeleteMemberModalOpen(false)}
>
  <DialogTitle>Confirm Member Deletion</DialogTitle>
  <DialogContent>
    <DialogContentText>
      Are you sure you want to delete {memberToDelete?.Fullname} {memberToDelete?.Original_pass}?
      This will permanently delete:
      <ul>
        <li>All their savings accounts</li>
        <li>All their transaction history</li>
        <li>Their membership records</li>
      </ul>
      This action cannot be undone.
    </DialogContentText>
    
  </DialogContent>
  <DialogActions>
    <Button 
      onClick={() => setDeleteMemberModalOpen(false)} 
    >
      Cancel
    </Button>
    <Button 
      onClick={deleteMember} 
      color="error"
    >
      Delete Permanently
    </Button>
  </DialogActions>
</Dialog>
      </Box>
    </div>
  )
}

export default AssociationMembers